import {
  $ModuleInfo,
  $SkillSetLevel,
  ModuleInfo,
  SkillSetLevel
} from '@suntex.fim/enums'

// eslint-disable-next-line no-magic-numbers
export type SkillSetGame = 1 | 2 | 3

export interface ISkillSet {
  level: SkillSetLevel
  game: SkillSetGame
}

const GAMES_PER_LEVEL = 3

// Convert moduleId (number or ModuleInfo) to SkillSetGame
export function toSkillSet(moduleId: number): ISkillSet {
  const level = $SkillSetLevel.from(Math.ceil(moduleId / GAMES_PER_LEVEL))
  const game = (((moduleId - 1) % GAMES_PER_LEVEL) + 1) as SkillSetGame
  return { level, game }
}

// Convert SkillSetGame back to ModuleInfo
export function toModuleId(data: ISkillSet): ModuleInfo {
  return $ModuleInfo.from(GAMES_PER_LEVEL * (data.level - 1) + data.game)
}
